import { render } from "./Wysiwyg.vue?vue&type=template&id=1e3a8034&scoped=true"
import script from "./Wysiwyg.vue?vue&type=script&lang=js"
export * from "./Wysiwyg.vue?vue&type=script&lang=js"

import "./Wysiwyg.vue?vue&type=style&index=0&id=1e3a8034&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1e3a8034"]])

export default __exports__